import api from './api/api';

const categoriesColor = {
  'Porte G': 'red-semi-light',
  'Reserva Ambiental': 'green-semi-light',
  'Alto Impacto': 'orange',
  Radiação: 'purple-light',
  'Dispensa Lai': 'cian',
};

// eslint-disable-next-line import/prefer-default-export
export const getCategoryColor = (category) => (Object.keys(categoriesColor).includes(category)
  ? categoriesColor[category]
  : undefined);

export const getAllCategories = async () => api.get('/licenses/tags').then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});

export const getCategoriesCounter = async () => api.get('/licenses/count').then((response) => {
  if (response.status === 200) return response.data;
  throw response.rejectException();
});
